module.exports = __webpack_public_path__ + "static/media/close.de4b005f.svg";